document.querySelectorAll('.work-orientation').forEach((button) => {
  button.addEventListener('click', () => {
    const card = button.closest('.work-card');
    const vertical = card.classList.toggle('is-vertical');
    button.setAttribute('aria-pressed', String(vertical));
    button.textContent = vertical ? 'Revenir à l’horizontale' : 'Voir aussi à la verticale';
    button.setAttribute('aria-label', vertical ? 'Revenir à l’orientation paysage de Réflexion' : 'Voir Réflexion en orientation verticale');
  });
});

// Protection légère des dérivés uniquement ; les masters ne sont pas publics.
document.addEventListener('dragstart', (event) => {
  if (event.target.closest('picture, .portfolio-lightbox-slide, .lightbox-slide')) event.preventDefault();
});
document.addEventListener('contextmenu', (event) => {
  if (event.target.closest('picture, .portfolio-lightbox-slide, .lightbox-slide')) event.preventDefault();
});

const menuButton = document.querySelector('.menu-button');
const nav = document.querySelector('.main-nav');
if (menuButton) menuButton.addEventListener('click', () => {
  const open = menuButton.getAttribute('aria-expanded') === 'true';
  menuButton.setAttribute('aria-expanded', String(!open));
  nav.classList.toggle('is-open', !open);
});
if (nav) nav.addEventListener('click', () => {
  menuButton.setAttribute('aria-expanded', 'false');
  nav.classList.remove('is-open');
});

const toast = document.querySelector('.demo-toast');
let toastTimer;
document.querySelectorAll('[data-demo]').forEach((button) => {
  button.addEventListener('click', (event) => {
    if (button.matches('a')) event.preventDefault();
    toast.textContent = button.dataset.demo;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2400);
  });
});

const lightbox = document.querySelector('#image-lightbox');
if (lightbox) {
  const mainMedia = document.querySelector('.artwork-main-image');
  const mainTrack = document.querySelector('.main-gallery-track');
  const mainSlides = [...document.querySelectorAll('.main-gallery-slide')];
  const galleryButtons = [...document.querySelectorAll('.gallery-thumb')];
  const lightboxViewport = lightbox.querySelector('.lightbox-viewport');
  const lightboxTrack = lightbox.querySelector('.lightbox-track');
  const closeButton = lightbox.querySelector('.lightbox-close');
  const previousLightboxButton = lightbox.querySelector('.lightbox-arrow.is-previous');
  const nextLightboxButton = lightbox.querySelector('.lightbox-arrow.is-next');
  let returnFocus;
  let activeIndex = 0;
  let lightboxIndex = 0;
  let presentationItems = null;
  let presentationIndex = 0;
  let pageScrollY = 0;
  let zoomScale = 1;
  let zoomX = 0;
  let zoomY = 0;
  const activePointers = new Map();
  let gestureStart = null;
  let pinchStartDistance = 0;
  let pinchStartScale = 1;
  let pinchOccurred = false;
  const touchInteractionQuery = matchMedia('(hover: none), (pointer: coarse)');

  const media = galleryButtons.map((button, index) => ({
    sourceIndex: index,
    src: button.dataset.gallerySrc || '',
    alt: button.dataset.galleryAlt || button.dataset.galleryLabel || '',
    label: button.dataset.galleryLabel || 'Visuel à venir',
    orientation: button.dataset.galleryOrientation || 'landscape',
    placeholder: !button.dataset.gallerySrc
  }));
  const availableMedia = media.filter((item) => !item.placeholder);

  const buildLightbox = () => {
    lightboxTrack.replaceChildren();
    const items = presentationItems || availableMedia;
    items.forEach((item, index) => {
      const slide = document.createElement('div');
      slide.className = 'lightbox-slide';
      let target;
      if (item.stage) {
        target = document.createElement('div');
        target.className = 'roscoff-zoom-composition';
        target.dataset.presentation = mainMedia.dataset.presentation;
        const stage = item.stage.cloneNode(true);
        stage.classList.add(`support-preview-${(item.viewIndex ?? index) + 1}`);
        stage.querySelector('img').src = item.src;
        stage.setAttribute('role', 'img');
        stage.setAttribute('aria-label', `${item.label} — simulation indicative`);
        target.append(stage);
      } else {
        target = document.createElement('img');
        target.src = item.src;
        target.alt = item.alt || item.label;
        target.draggable = false;
      }
      target.dataset.zoomTarget = '';
      slide.append(target);
      lightboxTrack.append(slide);
    });
  };
  buildLightbox();

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  const selectMedia = (index) => {
    if (index < 0 || index >= media.length) return;
    activeIndex = index;
    const currentMedia = media[index];
    galleryButtons.forEach((button, buttonIndex) => {
      const selected = buttonIndex === index;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    mainSlides.forEach((slide, slideIndex) => {
      const selected = slideIndex === index;
      slide.classList.toggle('is-active', selected);
      slide.setAttribute('aria-hidden', String(!selected));
    });
    mainMedia.classList.remove('is-zooming');
    mainMedia.classList.toggle('has-placeholder', currentMedia.placeholder);
    mainMedia.classList.toggle('is-portrait', currentMedia.orientation === 'portrait');
    mainMedia.setAttribute('aria-label', currentMedia.placeholder ? `${currentMedia.label}, visuel à venir` : `Agrandir ${currentMedia.label}`);
  };

  const currentLightboxImage = () => lightboxTrack.querySelectorAll('[data-zoom-target]')[lightboxIndex];

  const applyZoom = () => {
    const image = currentLightboxImage();
    if (!image) return;
    const maxX = Math.max(0, image.clientWidth * (zoomScale - 1) / 2);
    const maxY = Math.max(0, image.clientHeight * (zoomScale - 1) / 2);
    zoomX = Math.max(-maxX, Math.min(maxX, zoomX));
    zoomY = Math.max(-maxY, Math.min(maxY, zoomY));
    image.style.transform = `translate3d(${zoomX}px, ${zoomY}px, 0) scale(${zoomScale})`;
    lightbox.classList.toggle('is-zoomed', zoomScale > 1.01);
  };

  const resetZoom = () => {
    lightboxTrack.querySelectorAll('[data-zoom-target]').forEach((image) => { image.style.transform = ''; });
    zoomScale = 1;
    zoomX = 0;
    zoomY = 0;
    lightbox.classList.remove('is-zoomed');
  };

  const renderLightbox = (animate = true) => {
    resetZoom();
    lightboxTrack.classList.toggle('without-transition', !animate);
    lightboxTrack.style.transform = `translate3d(${-lightboxIndex * 100}%, 0, 0)`;
    const navigationUnavailable = (presentationItems || availableMedia).length < 2;
    const caption = lightbox.querySelector('[data-gallery-caption]');
    if (caption) caption.textContent = presentationItems?.[lightboxIndex]?.stage ? `${presentationItems[lightboxIndex].label} — simulation indicative` : '';
    previousLightboxButton.disabled = navigationUnavailable;
    nextLightboxButton.disabled = navigationUnavailable;
    if (!animate) requestAnimationFrame(() => lightboxTrack.classList.remove('without-transition'));
  };

  const moveLightbox = (direction) => {
    const items = presentationItems || availableMedia;
    if (items.length < 2) return;
    const nextIndex = (lightboxIndex + direction + items.length) % items.length;
    if (nextIndex === lightboxIndex) return;
    lightboxIndex = nextIndex;
    if (presentationItems) {
      mainMedia.dispatchEvent(new CustomEvent('roscoff:select-preview', {detail: {index: lightboxIndex}}));
    } else {
      activeIndex = availableMedia[lightboxIndex].sourceIndex;
      selectMedia(activeIndex);
    }
    renderLightbox();
  };

  const closeLightbox = () => {
    resetZoom();
    activePointers.clear();
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-lightbox-open');
    document.body.style.top = '';
    window.scrollTo(0, pageScrollY);
    if (returnFocus) returnFocus.focus();
  };

  const openLightbox = () => {
    if (touchInteractionQuery.matches) return;
    if (media[activeIndex].placeholder) {
      showToast(`${media[activeIndex].label} — visuel à venir`);
      return;
    }
    returnFocus = mainMedia;
    pageScrollY = window.scrollY;
    lightboxIndex = presentationItems ? presentationIndex : availableMedia.findIndex((item) => item.sourceIndex === activeIndex);
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.top = `-${pageScrollY}px`;
    document.body.classList.add('is-lightbox-open');
    renderLightbox(false);
    closeButton.focus();
  };

  galleryButtons.forEach((button, index) => {
    button.setAttribute('aria-pressed', String(index === 0));
    button.addEventListener('click', () => {
      selectMedia(index);
    });
  });

  let lastTouchAt = -Infinity;
  mainMedia.addEventListener('pointerdown', (event) => { if (event.pointerType === 'touch' || event.pointerType === 'pen') lastTouchAt = Date.now(); }, {passive: true});
  mainMedia.addEventListener('touchstart', () => { lastTouchAt = Date.now(); }, {passive: true});
  mainMedia.addEventListener('click', (event) => {
    if (event.button === 0 && !touchInteractionQuery.matches) return;
    if (event.pointerType === 'touch' || event.pointerType === 'pen' || Date.now() - lastTouchAt < 1000) return;
    openLightbox();
  });
  mainMedia.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    openLightbox();
  });

  mainMedia.addEventListener('pointermove', (event) => {
    if (mainMedia.classList.contains('has-support-preview') || media[activeIndex].placeholder || event.pointerType === 'touch' || event.pointerType === 'pen' || touchInteractionQuery.matches) return;
    const bounds = mainMedia.getBoundingClientRect();
    const x = ((event.clientX - bounds.left) / bounds.width) * 100;
    const y = ((event.clientY - bounds.top) / bounds.height) * 100;
    mainMedia.style.setProperty('--zoom-x', `${x}%`);
    mainMedia.style.setProperty('--zoom-y', `${y}%`);
    mainMedia.classList.add('is-zooming');
  });
  mainMedia.addEventListener('pointerleave', () => mainMedia.classList.remove('is-zooming'));

  mainMedia.addEventListener('roscoff:gallery', (event) => {
    presentationItems = event.detail.items;
    presentationIndex = 0;
    lightboxIndex = 0;
    buildLightbox();
    renderLightbox(false);
  });
  mainMedia.addEventListener('roscoff:gallery-select', (event) => {
    presentationIndex = event.detail.index;
  });
  lightbox.querySelectorAll('[data-zoom-step]').forEach(button => button.addEventListener('click', () => {
    zoomScale = Math.max(1, Math.min(4, zoomScale + Number(button.dataset.zoomStep)));
    if (zoomScale === 1) { zoomX = 0; zoomY = 0; }
    applyZoom();
  }));
  lightboxViewport.addEventListener('wheel', (event) => {
    if (lightbox.hidden) return;
    event.preventDefault();
    zoomScale = Math.max(1, Math.min(4, zoomScale + (event.deltaY < 0 ? .2 : -.2)));
    if (zoomScale === 1) { zoomX = 0; zoomY = 0; }
    applyZoom();
  }, {passive: false});

  previousLightboxButton.addEventListener('click', () => moveLightbox(-1));
  nextLightboxButton.addEventListener('click', () => moveLightbox(1));

  lightboxViewport.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch' && (zoomScale === 1 || event.button !== 0)) return;
    lightboxViewport.setPointerCapture(event.pointerId);
    activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (activePointers.size === 1) {
      gestureStart = { x: event.clientX, y: event.clientY, zoomX, zoomY };
      pinchOccurred = false;
    } else if (activePointers.size === 2) {
      const points = [...activePointers.values()];
      pinchStartDistance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
      pinchStartScale = zoomScale;
      pinchOccurred = true;
    }
  });

  lightboxViewport.addEventListener('pointermove', (event) => {
    if (!activePointers.has(event.pointerId)) return;
    activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (activePointers.size === 2) {
      const points = [...activePointers.values()];
      const distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
      zoomScale = Math.max(1, Math.min(4, pinchStartScale * distance / Math.max(pinchStartDistance, 1)));
      if (zoomScale <= 1.01) {
        zoomScale = 1;
        zoomX = 0;
        zoomY = 0;
      }
      applyZoom();
    } else if (activePointers.size === 1 && zoomScale > 1 && gestureStart) {
      zoomX = gestureStart.zoomX + event.clientX - gestureStart.x;
      zoomY = gestureStart.zoomY + event.clientY - gestureStart.y;
      applyZoom();
    }
  });

  const endPointerGesture = (event) => {
    const finalPoint = activePointers.get(event.pointerId);
    activePointers.delete(event.pointerId);
    if (activePointers.size === 1) {
      const remaining = [...activePointers.values()][0];
      gestureStart = { x: remaining.x, y: remaining.y, zoomX, zoomY };
      return;
    }
    if (activePointers.size > 0 || !gestureStart) return;
    if (!pinchOccurred && zoomScale === 1 && finalPoint) {
      const deltaX = finalPoint.x - gestureStart.x;
      const deltaY = finalPoint.y - gestureStart.y;
      if (Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) moveLightbox(deltaX < 0 ? 1 : -1);
    }
    gestureStart = null;
    pinchOccurred = false;
  };

  lightboxViewport.addEventListener('pointerup', endPointerGesture);
  lightboxViewport.addEventListener('pointercancel', endPointerGesture);

  closeButton.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (event) => {
    if (lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') moveLightbox(-1);
    if (event.key === 'ArrowRight') moveLightbox(1);
    if (event.key === 'Tab') {
      const focusable = [...lightbox.querySelectorAll('button:not([disabled])')];
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  selectMedia(0);
  renderLightbox(false);
}

